var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.0000038147,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.3273L8.3503 10.684C8.1558 10.875 7.8442 10.875 7.6497 10.684L8 10.3273ZM11.6497 6.04321C11.8468 5.84975 12.1633 5.85265 12.3568 6.0497C12.5502 6.24674 12.5473 6.56331 12.3503 6.75678L11.6497 6.04321ZM3.64971 6.75678C3.45266 6.56331 3.44976 6.24674 3.64322 6.0497C3.83668 5.85265 4.15325 5.84975 4.3503 6.04321L3.64971 6.75678ZM7.6497 9.97048L11.6497 6.04321L12.3503 6.75678L8.3503 10.684L7.6497 9.97048ZM7.6497 10.684L3.64971 6.75678L4.3503 6.04321L8.3503 9.97048L7.6497 10.684Z",
    fill: "#75CAC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenarrow);
export default __webpack_public_path__ + "static/media/greenarrow.2715b29d10c94cc4122e3815ad363d60.svg";
export { ForwardRef as ReactComponent };